import React, { useState } from 'react';
import { updateLevelConfig } from '../../utils/api';

const LevelIncome = ({ config, loadConfig, flash }) => {
  const p = [...(config.levelPercentages||[])]; while(p.length<21) p.push(0);
  const [levels, setLevels] = useState({ percentages: p, distributeLevels: config.distributeLevels||10 });

  const totalPct = levels.percentages.slice(1, levels.distributeLevels + 1).reduce((s, v) => s + (v || 0), 0);

  return (
    <div className="fade-in">
      <h2 className="adm-title">Level Income</h2>
      <p className="adm-hint">Income distributed to upline on every purchase. No eligibility criteria — if upline exists, they get paid.</p>
      <div className="adm-field" style={{maxWidth:200,marginBottom:20}}><label>Active Levels</label><input type="number" value={levels.distributeLevels} onChange={e=>setLevels({...levels,distributeLevels:parseInt(e.target.value)||1})} className="input" min="1" max="20"/></div>
      <div className="adm-level-table card">
        <div className="adm-level-hdr"><span>Level</span><span>Income % (of investment)</span></div>
        {Array.from({length:levels.distributeLevels},(_,i)=>i+1).map(lv=>(
          <div key={lv} className="adm-level-row">
            <span className="adm-level-num">Level {lv}</span>
            <input type="number" value={levels.percentages[lv]??0} step="0.25" onChange={e=>{const np=[...levels.percentages];np[lv]=parseFloat(e.target.value)||0;setLevels({...levels,percentages:np});}} className="input input-sm"/>
          </div>
        ))}
        <div className="adm-level-row" style={{fontWeight:700}}>
          <span>Total</span>
          <span className={`mono ${totalPct === (config.teamIncomePercent || 15) ? 'text-green' : 'text-red'}`}>{totalPct}% {totalPct !== (config.teamIncomePercent || 15) ? `(should be ${config.teamIncomePercent || 15}%)` : '✓'}</span>
        </div>
      </div>
      <button className="btn btn-primary adm-mt" onClick={async()=>{
        // Send with empty criteria (all zeros)
        const zeroCriteria = new Array(21).fill(0);
        try{await updateLevelConfig({distributeLevels: levels.distributeLevels, levelPercentages: levels.percentages, levelCriteria: zeroCriteria});flash('Saved');loadConfig();}catch(e){flash(e.response?.data?.error||'Failed','error');}
      }}>Save</button>
    </div>
  );
};

export default LevelIncome;